// import _ from '@lodash';
// import { useWorkflow } from 'app/admin/workflow/component/WorkflowProvider';
// import { useEffect, useState } from 'react';
// import { useFormContext } from 'react-hook-form';

// function inputChanged(input, value) {
//     if (input.name !== value.valueKey) return true;
//     if (input.type !== value.valueType) return true;
//     if (input.value !== value.value) return true;
//     return false;
// }

// function outputChanged(output, value) {
//     if (output.name !== value.valueKey) return true;
//     if (output.type !== value.valueType) return true;
//     if (output.uom !== value.uom) return true;
//     // if (output.value !== value.value) return true;
//     return false;
// }

// export default function WorkflowDataUpdater() {
//     const { data } = useWorkflow();
//     const { getValues, setValue } = useFormContext();

//     const [dataValue, setDataValue] = useState(null);

//     useEffect(() => {
//         // console.log('Workflow data updater.');
//         // console.log(data);
//         // console.log(dataValue);

//         if (data && data.value) {
//             const _dataValue = JSON.stringify(data.value);
//             if (dataValue == null || data.value !== dataValue) {

//                 const inputAttributes = getValues('inputAttributes');
//                 let inChanged = false;

//                 if (_.isArray(inputAttributes)) {
//                     const delInIdx = [];

//                     inputAttributes.forEach((inp, idx) => {
//                         if (data.value.findIndex(v => v.key === inp.key) === -1) delInIdx.push(idx);
//                     });

//                     if (delInIdx.length > 0) {
//                         delInIdx.sort().forEach((idx, ct) => inputAttributes.splice(idx - ct, 1));
//                         inChanged = true;
//                     }

//                     data.value.forEach(val => {
//                         if (val.io === 'INPUT') {
//                             const input = inputAttributes.find(inp => inp.key === val.key);
//                             // console.log('input', input);
//                             if (input) {
//                                 if (inputChanged(input, val)) {
//                                     input.name = val.valueKey;
//                                     input.type = val.valueType;
//                                     input.value = val.value;
//                                     input.uom = val.uom;
//                                     input.minified = val.minified;
//                                     inChanged = true;
//                                 }
//                             } else {
//                                 inputAttributes.push({
//                                     id: null,
//                                     name: val.valueKey,
//                                     key: val.key,
//                                     type: val.valueType,
//                                     value: val.value,
//                                     uom: val.uom,
//                                     // minified: val.minified
//                                 });
//                                 inChanged = true;
//                             }
//                         }
//                     });

//                     if (inChanged) setValue('inputAttributes', inputAttributes);
//                 }

//                 const outputAttributes = getValues('outputAttributes');

//                 let outChanged = false;

//                 if (_.isArray(outputAttributes)) {
//                     const delInIdx = [];

//                     outputAttributes.forEach((inp, idx) => {
//                         if (data.value.findIndex(v => v.key === inp.key) === -1) delInIdx.push(idx);
//                     });

//                     if (delInIdx.length > 0) {
//                         delInIdx.sort().forEach((idx, ct) => outputAttributes.splice(idx - ct, 1));
//                         outChanged = true;
//                     }

//                     data.value.forEach(val => {
//                         if (val.io === 'OUTPUT') {

//                             const output = outputAttributes.find(inp => inp.key === val.key);

//                             if (output) {
//                                 if (outputChanged(output, val)) {
//                                     output.name = val.valueKey;
//                                     output.type = val.valueType;
//                                     output.uom = val.uom;
//                                     output.value = val.value;
//                                     outChanged = true;
//                                 }
//                             } else {
//                                 outputAttributes.push({
//                                     id: null,
//                                     key: val.key,
//                                     name: val.valueKey,
//                                     type: val.valueType,
//                                     value: val.value,
//                                     uom: val.uom
//                                 });
//                                 outChanged = true;
//                             }

//                         }
//                     });

//                     if (outChanged) setValue('outputAttributes', outputAttributes);
//                 }

//                 setDataValue(_dataValue);
//             }
//         }
//     }, [data]);

//     if (data && data.valuen && dataValue == null)
//         setDataValue(JSON.stringify(data.value));

//     return <></>;
// }

import _ from '@lodash';
import { useWorkflow } from 'app/admin/workflow/component/WorkflowProvider';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

function inputChanged(input, value) {
    if (input.name !== value.valueKey) return true;
    if (input.type !== value.valueType) return true;
    if (input.value !== value.value) return true;
    return false;
}

function outputChanged(output, value) {
    if (output.name !== value.valueKey) return true;
    if (output.type !== value.valueType) return true;
    if (output.uom !== value.uom) return true;
    return false;
}

export default function WorkflowDataUpdater() {
    const { data } = useWorkflow();

    const form = useFormContext();
    const getValues = form?.getValues;
    const setValue = form?.setValue;

    const [dataValue, setDataValue] = useState(null);

    useEffect(() => {
        if (!form) return;

        if (data && data.value) {
            const _dataValue = JSON.stringify(data.value);
            if (dataValue == null || _dataValue !== dataValue) {
                const inputAttributes = getValues('inputAttributes');
                let inChanged = false;

                if (_.isArray(inputAttributes)) {
                    const delInIdx = [];
                    inputAttributes.forEach((inp, idx) => {
                        if (data.value.findIndex(v => v.key === inp.key) === -1) delInIdx.push(idx);
                    });
                    if (delInIdx.length > 0) {
                        delInIdx.sort().forEach((idx, ct) => inputAttributes.splice(idx - ct, 1));
                        inChanged = true;
                    }
                    data.value.forEach(val => {
                        if (val.io === 'INPUT') {
                            const input = inputAttributes.find(inp => inp.key === val.key);
                            if (input) {
                                if (inputChanged(input, val)) {
                                    input.name = val.valueKey;
                                    input.type = val.valueType;
                                    input.value = val.value;
                                    input.uom = val.uom;
                                    input.minified = val.minified;
                                    inChanged = true;
                                }
                            } else {
                                inputAttributes.push({
                                    id: null,
                                    name: val.valueKey,
                                    key: val.key,
                                    type: val.valueType,
                                    value: val.value,
                                    uom: val.uom,
                                });
                                inChanged = true;
                            }
                        }
                    });
                    if (inChanged) setValue('inputAttributes', inputAttributes);
                }

                const outputAttributes = getValues('outputAttributes');
                let outChanged = false;

                if (_.isArray(outputAttributes)) {
                    const delInIdx = [];
                    outputAttributes.forEach((inp, idx) => {
                        if (data.value.findIndex(v => v.key === inp.key) === -1) delInIdx.push(idx);
                    });
                    if (delInIdx.length > 0) {
                        delInIdx.sort().forEach((idx, ct) => outputAttributes.splice(idx - ct, 1));
                        outChanged = true;
                    }
                    data.value.forEach(val => {
                        if (val.io === 'OUTPUT') {
                            const output = outputAttributes.find(inp => inp.key === val.key);
                            if (output) {
                                if (outputChanged(output, val)) {
                                    output.name = val.valueKey;
                                    output.type = val.valueType;
                                    output.uom = val.uom;
                                    output.value = val.value;
                                    outChanged = true;
                                }
                            } else {
                                outputAttributes.push({
                                    id: null,
                                    key: val.key,
                                    name: val.valueKey,
                                    type: val.valueType,
                                    value: val.value,
                                    uom: val.uom,
                                });
                                outChanged = true;
                            }
                        }
                    });
                    if (outChanged) setValue('outputAttributes', outputAttributes);
                }

                setDataValue(_dataValue);
            }
        }
    }, [form, data, getValues, setValue, dataValue]);

    useEffect(() => {
        if (data?.value && dataValue == null) {
            setDataValue(JSON.stringify(data.value));
        }
    }, [data, dataValue]);

    return null;
}